import { CollectionHandles } from 'config/collections/types';
import { Region } from 'constants/shop';

// Example: { bundles: { [Region.DE]: 'probierpakete' } } -> { bundles: 'probierpakete' }
export const resolveHandles = <T extends CollectionHandles>(
  handles: T,
  region: Region = Region.DE
): Record<keyof T, string> => {
  const entries = Object.entries(handles).map(([key, regionalHandle]) => {
    const handle = regionalHandle[region] || regionalHandle[Region.DE];

    if (!handle) {
      throw new Error(`Collection handle is missing a DE fallback: ${key}`);
    }

    return [key, handle];
  });

  return Object.fromEntries(entries) as Record<keyof T, string>;
};
